var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8032_3122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 28,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 27.6316,
    height: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8032_3122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6054 31.8334C13.9721 31.8334 13.4301 31.6294 12.9791 31.2214C12.5282 30.8135 12.3027 30.323 12.3027 29.7501V17.2501C12.3027 16.6772 12.5282 16.1867 12.9791 15.7787C13.4301 15.3707 13.9721 15.1667 14.6054 15.1667H21.5133L23.8159 17.2501H33.0264C33.6596 17.2501 34.2017 17.4541 34.6527 17.8621C35.1036 18.27 35.329 18.7605 35.329 19.3334H22.8661L20.5634 17.2501H14.6054V29.7501L17.3685 21.4167H37.056L34.0914 30.349C33.9379 30.8004 33.6548 31.1607 33.2423 31.4298C32.8297 31.6989 32.374 31.8334 31.8751 31.8334H14.6054ZM17.0231 29.7501H31.8751L33.9475 23.5001H19.0955L17.0231 29.7501Z",
    fill: "#0A8BC7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.9cd1fbdfb0d2ec9404a0e27b2242442a.svg";
export { ForwardRef as ReactComponent };